export const SITEMAP_LOCAL_STORAGE_KEY = 'sf_builder_sitemap_state';

export const TEMPLATES_KEYWORD = 'Template';

export const SOURCE_LEGEND = {
  codebase: { label: 'Base' },
  category: { label: 'Category' },
  builder: { label: 'Builder' },
  job: { label: 'Job' },
};

export const VIEW_OPTIONS = [
  { label: 'Tree', icon: <i className="fe fe-align-right" /> },
  { label: 'List', icon: <i className="fe fe-list" /> },
];

export const HIDE_OPTIONS = {
  categories: SOURCE_LEGEND.category.label,
  builder: SOURCE_LEGEND.builder.label,
  codebase: SOURCE_LEGEND.codebase.label,
};

export const SORT_OPTIONS = [
  { label: 'Title', value: 0 },
  { label: 'URL', value: 1 },
  { label: 'Date Updated', value: 2 },
];

export const SORT_ORDER = [
  { label: 'ASC', value: 0 },
  { label: 'DESC', value: 1 },
];

export const STATUS_LEGEND = {
  live: { label: 'Live', variant: 'first', backgroundColor: 'text-bg-success' },
  draft: { label: 'Draft', variant: 'second', backgroundColor: 'text-bg-secondary' },
  pending: { label: 'Pending', variant: 'third', backgroundColor: 'text-bg-info' },
};
